import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NetworkOverview from './network-overview';
import ArenaConfigurator from './arena-configurator';
import NetworkConfigurator from './network-configurator';
import { useStringsContext } from '../../../contexts/strings';
import SceneHeader from '../../common/scene/scene-header';
import ScenePage from '../../common/scene/scene-page';

function WifiScene() {
  const { strings } = useStringsContext();

  return (
    <ScenePage title={strings.appBar.wifi} breadCrumps={[strings.appBar.superAdmin]}>
      <SceneHeader title={strings.appBar.wifi} border />
      <Switch>
        <Route exact path="/wifi/network" component={NetworkOverview} />
        <Route exact path="/wifi/arenaconfigurator/:arena" component={ArenaConfigurator} />
        <Route exact path="/wifi/networkconfigurator/:arena" component={NetworkConfigurator} />
      </Switch>
    </ScenePage>
  );
}

export default WifiScene;
